import React from "react";

import Framework from "@beardeddevops/react.framework";
import API from "@beardeddevops/react.api"
import Types from "constants/Types";
import APPCONFIG from "constants/Config";
import {Button} from "reactstrap";
import {Collections} from "components";
import UniversalModalOverride from "components/UniversalModalOverride";
import ObjectOverride from "components/ObjectOverride";
import FFLTextField from "components/Elements/FFLTextField";


/**
 *
 */
export default class FormP12 extends ObjectOverride {
	constructor(props) {
		super(props, Types.Form_P12s._name);
	}

	/**
	 * @param Form_P12s_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
	}


	componentDidMount() {
		const tDate = new Date(this.props.transaction_date);
		if(this.props.products) {
			this.setState({
				products: this.props.products,
				month_day_year: tDate.toLocaleDateString('en-US', {
					month: '2-digit', // Display the month as two digits (e.g., 01 for January)
					day: '2-digit',   // Display the day as two digits (e.g., 01 for the 1st)
					year: 'numeric'   // Display the full year (e.g., 2024)
				}),

			})

			//Object is called from an acquisiton
		if(this.props.acq_state) {
			let isDealer = false;
			if(this.props.acq_state.customer === null) {
				isDealer = true;
			}

			this.setState({
				received_from: true,
				sold_received_repaired_name: isDealer ? this.formatDealerName('acq_state') : this.formatCustomerName('acq_state'),
				address: isDealer ? this.formatDealerAddress('acq_state') : this.formatCustomerAddress('acq_state'),
				date_of_birth: isDealer ? '' : new Date(this.props.acq_state.customers.birth_date),
				address_secondary: this.formatLocationAddress('acq_state'),
				county: this.props.acq_state.locations_related_by_location.county,
				pistol_license_number_nysp_dealer_code_ffl: isDealer ? this.props.acq_state.dealer_ffl : (typeof this.props?.customer_permit?.Number !== 'undefined') ? this.props.customer_permit.Number : '',
				issuing_authority: isDealer ? 'ATF' : (typeof this.props?.customer_permit?.Number !== 'undefined') ? 'JUDGE' : '',
				occupation: isDealer ? 'N/A' : '',
				dealer_gunsmith: this.formatLocationName('acq_state')
			})
		}


		//Object is called from a disposition
		if(this.props.dispo_state) {
			this.setState({
				sold_to: true,
				address: this.formatCustomerAddress('dispo_state'),
				sold_received_repaired_name: this.formatCustomerName('dispo_state'),
				date_of_birth: this.props.dispo_state.customers.birth_date,
				county: this.props.dispo_state.locations_related_by_location.county,
				pistol_license_number_nysp_dealer_code_ffl: this.props.dispo_state.locations_related_by_location.ffl,
				dealer_gunsmith: this.formatLocationName('dispo_state'),
				address_secondary: this.formatLocationAddress('dispo_state'),
				issuing_authority: 'ATF'
				})
			}

			if(this.props.transfer_state) {
				this.setState({
					sold_to: true,
					address: this.formatDealerAddress('transfer_state'),
					sold_received_repaired_name: this.formatDealerName('transfer_state'),
					date_of_birth: '',
					county: this.props.transfer_state.locations_related_by_location.county,
					pistol_license_number_nysp_dealer_code_ffl: this.props.transfer_state.dealer_ffl,
					dealer_gunsmith: this.formatLocationName('transfer_state'),
					address_secondary: this.formatLocationAddress('transfer_state'),
					issuing_authority: 'ATF'
				})
			}


		}

		if(typeof this.props.p12_object !== 'undefined') {
			for(const element in this.props.p12_object) {
				this.state[element] = this.props.p12_object[element];
				this.state[element + '_error'] = '';
			}

			this.setState({key: Math.random()})
		}
	}




	/**
	 *
	 * @param state_type
	 * @returns {string}
	 */
	formatCustomerName = (state_type) => {
		if(this.props[state_type].customer_name_middle === '') {
			return this.props[state_type].customer_name_first + ' ' + this.props[state_type].customer_name_last
		}
		else {
			return this.props[state_type].customer_name_first + ' ' + this.props[state_type].customer_name_middle + ' ' + this.props[state_type].customer_name_last;
		}
	}

	/**
	 *
	 * @param state_type
	 * @returns {string}
	 */
	formatCustomerAddress = (state_type) => {
		return (this.props[state_type].customer_street_1 + ', ' + this.props[state_type].customer_city + ', ' + this.props[state_type].customer_state + ' ' + this.props[state_type].customer_zip);
	}

	/**
	 *
	 * @param state_type
	 * @returns {string}
	 */
	formatDealerAddress = (state_type) => {
		if(this.props[state_type].dealers.street_1 === '' ) {
			return '';
		}
		if(this.props[state_type].dealers.city === '' && this.props[state_type].dealers.zip === '' && this.props[state_type].dealers.street_1 === '' ) {
			return (this.props[state_type].dealers.street_1 + ', ' + this.props[state_type].dealers.state);
		}
		return (this.props[state_type].dealers.street_1 + ', ' + this.props[state_type].dealers.city + ', ' + this.props[state_type].dealers.state + ' ' + this.props[state_type].dealers.zip);
	}

	/**
	 *
	 * @param state_type
	 * @returns {?text|string}
	 */
	formatDealerName = (state_type) => {
		return (this.props[state_type].dealers.name_display === '' || this.props[state_type].dealers.name_display === null) ? (this.props[state_type].dealers.name_company) : (this.props[state_type].dealers.name_display);
	}

	/**
	 *
	 * @param state_type
	 * @returns {string}
	 */
	formatLocationAddress = (state_type) => {
		if(this.props[state_type].locations_related_by_location.street_1 === '' ) {
			return '';
		}
		return (this.props[state_type].locations_related_by_location.street_1 + ', ' + this.props[state_type].locations_related_by_location.city + ', ' + this.props[state_type].locations_related_by_location.state + ' ' + this.props[state_type].locations_related_by_location.zip);
	}


	/**
	 *
	 * @param state_type
	 * @returns {?text|string|*}
	 */
	formatLocationName = (state_type) => {
		return (this.props[state_type].locations_related_by_location.name_display !== ' ') ? this.props[state_type].locations_related_by_location.name_display : this.props[state_type].locations_related_by_location.name_company;
	}

	async handleSubmit() {

		if(this.props.p12_object) {
			let updatePModel = new API.BuildClass(Types.Form_P12s._name, API.RequestType.CREATE);
			await updatePModel.submit(this, 'PUT_FORM_P12');

			this.props.afterSave();
		}
		else {
			let pModel = new API.BuildClass(Types.Form_P12s._name, API.RequestType.CREATE);
			this.request = 'PUT_FORM_P12';
			this.state.collection = this.props.collection.split('-')[1];
			this.state.collection_binary_id = this.props.collection.split('-')[0];
			pModel.submit(this, 'PUT_FORM_P12');
			this.props.afterSave();
		}
	}


	form = () => {
		/** @type {Form_P12s_Properties} properties */
		let properties = this.model.properties;
		/** @type {Form_P12s_Object} object */
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset>
					<div className={"row"}>
						<div className={"col-4"}>
							<Framework.Elements.Date
								label={"Month/Day/Year"}
								property={properties.month_day_year}
								value={object.month_day_year}
								error={object.month_day_year_error}
								update={this.handleTextFieldPropertyUpdate}
							/>
						</div>
						<div className={"col-1"}>
							<Framework.Elements.Checkbox
								value={object.sold_to}
								property={properties.sold_to}
								error={object.sold_to_error}
								update={() => (this.setState({sold_to: !this.state.sold_to}))}
								color="primary"
								label={'Sold To'}
							/>
						</div>
						<div className={"col-1"}>
							<Framework.Elements.Checkbox
								value={object.received_from}
								property={properties.received_from}
								error={object.received_from_error}
								update={() => (this.setState({received_from: !this.state.received_from}))}
								color="primary"
								label={'Received From'}
							/>
						</div>
						<div className={"col-1"}>
							<Framework.Elements.Checkbox
								style={{marginLeft: '30px'}}
								value={object.repaired_for}
								property={properties.repaired_for}
								error={object.repaired_for_error}
								update={() => (this.setState({repaired_for: !this.state.repaired_for}))}
								color="primary"
								label={'Repaired For'}
							/>
						</div>
						<div className={"col-4"}>
							<Framework.Elements.TextField
								style={{marginLeft: '96px'}}
								label={"Name"}
								property={properties.sold_received_repaired_name}
								value={object.sold_received_repaired_name}
								error={object.sold_received_repaired_name_error}
								update={this.handleTextFieldPropertyUpdate}
							/>
						</div>
					</div>
					<div className={"row"}>
						<div className={"col-10"}>
							<Framework.Elements.TextField
								label={"Address"}
								property={properties.address}
								value={object.address}
								error={object.address_error}
								update={this.handleTextFieldPropertyUpdate}
							/>
						</div>
						<div className={"col-2"}>
							<Framework.Elements.Date
								label={"Birth Date"}
								property={properties.date_of_birth}
								value={object.date_of_birth}
								error={object.date_of_birth_error}
								update={this.handleTextFieldPropertyUpdate}
							/>
						</div>
					</div>
					<br/>
					<div className={"row"}>
						<div className={"col-4"}>
							<Framework.Elements.TextField
								label={"Occupation"}
								property={properties.occupation}
								value={object.occupation}
								error={object.occupation_error}
								update={this.handleTextFieldPropertyUpdate}
							/>
						</div>
						<div className={"col-6"}>
							<Framework.Elements.TextField
								label={"Employer/Agency"}
								property={properties.employer_agency}
								value={object.employer_agency}
								error={object.employer_agency_error}
								update={this.handleTextFieldPropertyUpdate}
							/>
						</div>
						<div className={"col-2"}>
							<Framework.Elements.TextField
								label={"Badge Number"}
								property={properties.badge_number}
								value={object.badge_number}
								error={object.badge_number_error}
								update={this.handleTextFieldPropertyUpdate}
							/>
						</div>
					</div>
					<br/>
					<div className={"row"}>
						<div className={"col-10"}>
							<Framework.Elements.TextField
								label={"Pistol License # / NYSP Dealer Code / FFL"}
								property={properties.pistol_license_number_nysp_dealer_code_ffl}
								value={object.pistol_license_number_nysp_dealer_code_ffl}
								error={object.pistol_license_number_nysp_dealer_code_ffl_error}
								update={this.handleTextFieldPropertyUpdate}
							/>
						</div>
						<div className={"col-2"}>
							<Framework.Elements.Date
								label={"Date Issued"}
								property={properties.date_issued}
								value={object.date_issued}
								error={object.date_issued_error}
								update={this.handleTextFieldPropertyUpdate}
							/>
						</div>
					</div>
					<br/>
					<div className={"row"}>
						<div className={"col-10"}>
							<Framework.Elements.TextField
								label={"Issuing Authority"}
								property={properties.issuing_authority}
								value={object.issuing_authority}
								error={object.issuing_authority_error}
								update={this.handleTextFieldPropertyUpdate}
							/>
						</div>
						<div className={"col-2"}>
							<Framework.Elements.TextField
								label={"County"}
								property={properties.county}
								value={object.county}
								error={object.county_error}
								update={this.handleTextFieldPropertyUpdate}
							/>
						</div>
					</div>
					<br/>
					<div className={"row"}>
						<div className={"col-10"}>
							<Framework.Elements.TextField
								label={"Dealer / Gunsmith"}
								property={properties.dealer_gunsmith}
								value={object.dealer_gunsmith}
								error={object.dealer_gunsmith_error}
								update={this.handleTextFieldPropertyUpdate}
							/>
						</div>
						<div className={"col-2"}>
							<Framework.Elements.TextField
								label={"NYSP Code #"}
								property={properties.nysp_code_number}
								value={object.nysp_code_number}
								error={object.nysp_code_number_error}
								update={this.handleTextFieldPropertyUpdate}
							/>
						</div>
					</div>
					<br/>
					<div className={"row"}>
						<div className={"col-12"}>
							<Framework.Elements.TextField
								label={"Address"}
								property={properties.address_secondary}
								value={object.address_secondary}
								error={object.address_secondary_error}
								update={this.handleTextFieldPropertyUpdate}
							/>
						</div>
					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	};

}
